import React from 'react';
import ReactDOM from 'react-dom';
import createStore from './store/createStore';

import 'semantic-ui-css/semantic.min.css';
import 'react-table/react-table.css';
import './styles/main.scss';

import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { checkSession } from './security/modules/actionsAuth';

// Store Initialization
// ------------------------------------
export const store = createStore(window.__INITIAL_STATE__);

// Create redux store and sync with react-router-redux. We have installed the
// react-router-redux reducer under the key "router" in src/routes/index.js,
// so we need to provide a custom `selectLocationState` to inform
// react-router-redux of its location.
const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: (state) => state.router,
});
// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root');

let render = () => {
  const App = require('./components/App').default;
  const routes = require('./routes/index').default(store);

  /* Inyecto el reducer de ath  a este nivel ya que necesito que este inicializado
  * antes que routes/index, el proceso de chequeo de autenticacion inicia con la
  * entrada del usuario antes que cualquier otro flujo.Ver onEnter: requireAuth,
  */
  const { injectReducer } = require('store/reducers');
  const authReducer = require('security/modules/auth').default;
  // const {getMedicoByEmail} = require('security/services/auth')
  /*  Add the reducer to the store on key 'counter'  */
  injectReducer(store, { key: 'auth', reducer: authReducer });
  // store.dispatch(getMedicoByEmail())
  store.dispatch(checkSession());

  ReactDOM.render(
    <App store={store} routes={routes} history={history} />,
    MOUNT_NODE,
  );
};

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = (error) => {
      const RedBox = require('redbox-react').default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept([
      './components/App',
      './routes/index',
    ], () => setImmediate(() => {
      ReactDOM.unmountComponentAtNode(MOUNT_NODE);
      render();
    }));
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render();



// WEBPACK FOOTER //
// ./src/main.js